import { create } from "zustand";

// Type definition for BeforeInstallPrompt event
type BeforeInstallPromptEvent = Event & {
  prompt: () => void;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

interface BeforeInstallPromptState {
  // State
  deferredPrompt: BeforeInstallPromptEvent | null;
  isInstallable: boolean;

  // Actions
  setDeferredPrompt: (event: BeforeInstallPromptEvent | null) => void;
  setIsInstallable: (value: boolean) => void;
  promptInstall: () => void;
}

export const useBeforeInstallPromptState = create<BeforeInstallPromptState>(
  (set, get) => ({
    // Initial state
    deferredPrompt: null,
    isInstallable: false,

    // Actions
    setDeferredPrompt: (event) => set({ deferredPrompt: event }),
    setIsInstallable: (value) => set({ isInstallable: value }),
    promptInstall: () => {
      const { deferredPrompt } = get();
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
          // eslint-disable-next-line no-console
          console.log("User choice:", choiceResult.outcome);
          set({ deferredPrompt: null, isInstallable: false });
        });
      }
    },
  }),
);

// Initialize event listener
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", ((event: Event) => {
    event.preventDefault();
    const promptEvent = event as BeforeInstallPromptEvent;
    useBeforeInstallPromptState.getState().setDeferredPrompt(promptEvent);
    useBeforeInstallPromptState.getState().setIsInstallable(true);
  }) as EventListener);
}
